import { IHavePath } from "../types/IHavePath";

export interface ISystemDocPath {}

export const SystemDocPathMeta: IHavePath = { path: "/system-doc" };
